/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { ActionMenuItemProps } from '../../../../shared/views/ActionMenu/ActionMenu';
import ActionMenuItemView from '../../../../shared/views/ActionMenu/ActionMenuItem.view';

interface Props extends ActionMenuItemProps {
	handleSave: () => void;
}

class ResendVerificationMailActionView extends Component<Props> {
	render(): JSX.Element {
		const { handleSave, renderMenuItem } = this.props;
		return (
			<ActionMenuItemView
				renderMenuItem={renderMenuItem}
				icon={<MailOutlineIcon color="primary" />}
				text="E-Mail-Bestätigung anfordern"
				action={handleSave}
			/>
		);
	}
}

export default ResendVerificationMailActionView;
